import { doc, runTransaction } from 'firebase/firestore'
import {
  formatLeadNumber,
  LEAD_NUMBER_COUNTER_COLLECTION,
  LEAD_NUMBER_COUNTER_DOC_ID,
} from '@otw/models/leads/leadNumber'
import { db as firestore } from 'config/firebase'

/**
 * Atomically allocates the next lead number from `counters/lead_numbers`.
 * The year suffix reflects `createdAt`; the sequence is global and monotonic.
 */
export const allocateLeadNumber = async (createdAt: Date = new Date()): Promise<string> => {
  const counterRef = doc(firestore, LEAD_NUMBER_COUNTER_COLLECTION, LEAD_NUMBER_COUNTER_DOC_ID)

  return runTransaction(firestore, async (transaction) => {
    const counterSnap = await transaction.get(counterRef)
    const nextSequence = counterSnap.exists()
      ? Math.max(1, Number(counterSnap.data()?.next) || 1)
      : 1

    const leadNumber = formatLeadNumber(nextSequence, createdAt)
    transaction.set(counterRef, { next: nextSequence + 1 }, { merge: true })
    return leadNumber
  })
}
